<template>
	<div>
		<v-dialog :key="dialogKey" v-model="showDialog" persistent scrollable :max-width="$vuetify.breakpoint.mobile ? '75%' : '50%'">
			<v-card class="justify-center text-center card-rounded pb-5" min-height="75vh">
				<v-card-title
					class="pa-2 white--text justify-center text-center secondary"
					style="font-family: Montserrat; font-style: normal; font-weight: bold; font-size: 12px; line-height: 7px; text-align: center"
				>
					<v-row>
						<v-spacer></v-spacer>
						<span class="headline white--text">Set Your Availability</span>
						<v-tooltip bottom>
							<template #activator="{ on, attrs }">
								<v-icon class="ml-1" color="primary" dark v-bind="attrs" small v-on="on"> help </v-icon>
							</template>
							<span
								><v-row><v-col>Select your dates to update your calendar as either available or unavailable</v-col></v-row></span
							>
						</v-tooltip>
						<v-spacer></v-spacer>
					</v-row>
					<v-btn icon color="white" @click="close">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>

				<v-card-text class="text-center justify-center">
					<v-container class="card-rounded pb-2 text-center justify-center">
						<div>
							<v-row>
								<v-col class="justify-center text-center">
									<v-btn-toggle v-model="calendarInputMode" mandatory>
										<v-btn
											rounded
											small
											:color="calendarInputMode == 0 ? 'primary' : '#FFF'"
											:class="[calendarInputMode == 0 ? 'white--text' : 'orange--text text--darken-2']"
											style="
												border-radius: 20px 0px 0px 20px;
												font-family: Montserrat;
												font-style: normal;
												font-weight: bold;
												font-size: 14px;
												line-height: 17px;
												text-align: center;
											"
										>
											Date range
										</v-btn>

										<v-btn
											rounded
											small
											:color="calendarInputMode == 1 ? 'primary' : '#FFF'"
											:class="[calendarInputMode == 1 ? 'white--text' : 'orange--text text--darken-2']"
											style="
												border-radius: 0px 20px 20px 0px;
												font-family: Montserrat;
												font-style: normal;
												font-weight: bold;
												font-size: 14px;
												line-height: 17px;
												text-align: center;
											"
										>
											Specific days
										</v-btn>
									</v-btn-toggle>
								</v-col>
							</v-row>
							<v-date-picker
								v-model="selectedDates"
								:min="new Date().toISOString().substr(0, 10)"
								header-color="primary"
								color="primary"
								full-width
								no-title
								:multiple="calendarInputMode == 1"
								:range="calendarInputMode == 0"
								class="elevation-0"
							></v-date-picker>
							<v-form ref="form" v-model="form">
								<v-row>
									<v-col>
										<v-text-field v-model="startdate" :rules="[rules.startdate]" label="Start Date:" filled dense readonly></v-text-field>
									</v-col>

									<v-col>
										<v-text-field v-model="enddate" :rules="[rules.enddate]" label="End Date:" filled dense readonly></v-text-field>
									</v-col>
								</v-row>

								<p class="font-weight-bold">Time</p>

								<v-row>
									<v-col>
										<v-dialog ref="starttimedialog" v-model="starttimemodal" :return-value.sync="starttime" persistent width="290px">
											<template #activator="{ on }">
												<v-text-field v-model="starttime" label="Start Time:" placeholder="Start Time:" readonly filled dense v-on="on"></v-text-field>
											</template>
											<v-time-picker v-if="starttimemodal" v-model="starttime" full-width format="24hr" :allowed-minutes="[0, 15, 30, 45]">
												<v-spacer></v-spacer>
												<v-btn text color="primary" @click="starttimemodal = false">Cancel</v-btn>
												<v-btn text color="primary" @click="$refs.starttimedialog.save(starttime)">OK</v-btn>
											</v-time-picker>
										</v-dialog>
									</v-col>

									<v-col>
										<v-dialog ref="endtimedialog" v-model="endtimemodal" :return-value.sync="endtime" persistent width="290px">
											<template #activator="{ on }">
												<v-text-field v-model="endtime" label="End Time" placeholder="End Time:" readonly filled dense v-on="on"></v-text-field>
											</template>
											<v-time-picker v-if="endtimemodal" v-model="endtime" full-width format="24hr" :allowed-minutes="[0, 15, 30, 45]">
												<v-spacer></v-spacer>
												<v-btn text color="primary" @click="endtimemodal = false">Cancel</v-btn>
												<v-btn text color="primary" @click="$refs.endtimedialog.save(endtime)">OK</v-btn>
											</v-time-picker>
										</v-dialog>
									</v-col>
								</v-row>

								<v-row>
									<v-col>
										<v-select
											v-model="availabilityOption"
											:items="offerOptions"
											:value="'Available'"
											filled
											:rules="[v => !!v || 'Offer type is required']"
											dense
											label="Mark days as"
											no-data-text="No more options to select"
											hide-selected
											required
										></v-select>
									</v-col>
								</v-row>
							</v-form>
						</div>
					</v-container>
				</v-card-text>
				<v-card-actions>
					<v-row class="pb-1">
						<v-spacer />
						<v-col :cols="3" align="center" justify="center">
							<v-btn block class="white--text mt-1" :height="30" color="primary" @click="doLocumUpdateAvailability()"
								><span style="font-size: 10px">Save Availability</span></v-btn
							>
						</v-col>
					</v-row>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<!-- Show dates overlapping error -->
		<v-dialog v-model="showErrorPopup" persistent :max-width="$vuetify.breakpoint.mobile ? '75%' : '50%'">
			<v-card class="justify-center text-center card-rounded pb-5" min-height="20vh" style="overflow-x: hidden">
				<v-card-title
					class="pa-2 white--text justify-center text-center secondary"
					style="font-family: Montserrat; font-style: normal; font-weight: bold; font-size: 12px; line-height: 7px; text-align: center"
				>
					<v-row>
						<v-spacer></v-spacer>
						<span class="headline white--text">Error</span>
						<v-spacer></v-spacer>
					</v-row>
				</v-card-title>

				<v-card-text>
					<v-container>
						<v-form>
							<v-row>
								<v-col class="justify-center text-center"> The selected dates overlap with an existing event, please select new dates. </v-col>
							</v-row>
						</v-form>
					</v-container>
				</v-card-text>
				<v-card-actions>
					<v-row class="pb-1">
						<v-spacer />
						<v-col :cols="3" align="center" justify="center">
							<v-btn block class="white--text mt-1" :height="30" color="secondary" @click="showErrorPopup = false"><span style="font-size: 10px">OK</span></v-btn>
						</v-col>
					</v-row>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { bus } from '@/main';
import store from '@/store';
import moment from 'moment';
import { getDefaultShiftTimes } from '@/utils/util';

export default {
	name: 'LocumEditAvailabilityDialog',
	components: {},
	data: () => ({
		dialogKey: 0,
		showDialog: false,
		user: store.getters.user,
		calendarInputMode: 0,
		form: false,

		showErrorPopup: false,

		range: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],

		today: moment(),
		startdatemodal: false,
		enddatemodal: false,

		starttime: '09:00',
		endtime: '17:00',

		startdate: null,
		enddate: null,
		minDate: new Date().toISOString().substr(0, 10),

		starttimemodal: false,
		endtimemodal: false,

		hasError: false,

		selectedDatesSorted: [],

		industriesConfigsObj: store.getters.configs.industries,

		availabilityOption: 'Available',

		offerOptions: ['Available', 'Unavailable'],

		apiRequest: false,

		rules: {
			startdate: v => !!v || 'Start date required',
			enddate: v => !!v || 'End date required',
		},
		showEditRequestTimeDialog: false,
		EditRequestTimeDialogTitle: '',
		startTimeEdit: '',
		endTimeEdit: '',
		startTimeChange: '', //variable for dialog to keep separate to not update time incase of cancel
		endTimeChange: '', //variable for dialog to keep separate to not update time incase of cancel
		request_dates: [],
		firstLoad: true,
		id: null,
		availability_code: '',
	}),
	computed: {
		...mapGetters('bookings', ['professionalConfirmedBookings', 'professionalBookingsRequests']),

		...mapGetters('availability', ['professionalAvailability']),

		selectedDates: {
			get: function () {
				return this.selectedDatesSorted;
			},
			set: function (newValue) {
				this.selectedDatesSorted = newValue.sort((a, b) => moment(a).diff(b, 'days'));
			},
		},
		userProfession() {
			return this.user.profession || null;
		},

		computedstartDateFormattedMomentjs() {
			return this.startdate ? moment(this.startdate).format('dddd, MMMM Do YYYY') : '';
		},
		computedendDateFormattedMomentjs() {
			return this.enddate ? moment(this.enddate).format('dddd, MMMM Do YYYY') : '';
		},
		availsetting() {
			if (this.availabilityOption === 'Available') {
				return 'open';
			}
			if (this.availabilityOption === 'Unavailable') {
				return 'unavailable';
			} else {
				return 'open';
			}
		},
		relevantProfessions() {
			if (this.user.industry) {
				return this.industriesConfigsObj[this.user.industry];
			} else {
				return [];
			}
		},
		isAvailability() {
			return this.availabilityOption === 'Available';
		},
	},
	watch: {
		selectedDatesSorted() {
			this.checkExistingEvents();
			this.startdate = this.selectedDatesSorted[0];
			this.enddate = this.selectedDatesSorted[this.selectedDatesSorted.length - 1];
		},
	},
	created() {
		const { start, end } = getDefaultShiftTimes(this.tenant);
		this.starttime = start;
		this.endtime = end;
	},

	methods: {
		...mapActions('availability', ['UpsertAvailability']),
		async open(booking, bookingType) {
			this.showDialog = true;
			this.dialogKey += 1;
			this.initData(booking, bookingType);
		},

		close() {
			this.selectedDates = [];
			this.selectedDatesSorted = [];
			this.showDialog = false;
		},

		initData(booking, bookingType) {
			this.selectedDates = booking.booking_dates;
			this.starttime = booking.start_time;
			this.endtime = booking.end_time;
			this.availabilityOption = bookingType;
			this.id = booking.id;
			this.availability_code = booking.availability_code;
		},

		allowedEndDates(val) {
			return this.startdate ? moment(val).isSameOrAfter(moment(this.startdate)) : true;
		},
		allowedStartDates(val) {
			return this.enddate ? moment(val).isSameOrBefore(moment(this.enddate)) : true;
		},

		allowedDatesAll(val) {
			return this.allowedEndDates(val) && this.allowedStartDates(val);
		},

		functionEvents(date) {
			const [, , day] = date.split('-');
			if ([12, 17, 28].includes(parseInt(day, 10))) return true;
			if ([1, 19, 22].includes(parseInt(day, 10))) return ['primary', 'accent'];
			return false;
		},

		cancelLocumSetAvailability() {
			bus.$emit('change-context', 'locum-dashboard-landing-zone');
		},

		isTwoDayShift(start_time, end_time, date) {
			const start = moment(`${date} ${start_time}`);
			let end = moment(`${date} ${end_time}`);
			return moment(start).isAfter(end);
		},

		async doLocumUpdateAvailability() {
			this.apiRequest = true;

			let dates = [];
			if (this.calendarInputMode == 1) {
				dates = this.selectedDatesSorted;
			} else {
				let startDay = this.selectedDatesSorted[0];
				let endDay = this.selectedDatesSorted[this.selectedDatesSorted.length - 1];
				const countDays = startDay === endDay ? 0 : moment(endDay).startOf('day').diff(moment(startDay).endOf('day'), 'days') + 1;

				for (let day_index = 0; day_index <= countDays; day_index++) {
					let day = moment(startDay).add(day_index, 'days');
					dates.push(day.format('YYYY-MM-DD'));
				}
			}

			const canCreateAvailability = this.checkExistingEvents(dates);
			if (!canCreateAvailability) {
				this.apiRequest = false;
				this.showErrorPopup = true;
				return;
			}

			const start_date = dates[0];
			const end_date = dates[dates.length - 1];

			const start_time_iso = moment(`${start_date} ${this.starttime}`).format();
			let end_time_iso = moment(`${end_date} ${this.endtime}`).format();

			const multipleDayShift = this.isTwoDayShift(this.starttime, this.endtime, start_date);
			if (multipleDayShift) {
				end_time_iso = moment(end_time_iso).add('days', 1).format();
			}

			const body = {
				id: this.id,
				status: this.availsetting,
				start_time: this.starttime,
				end_time: this.endtime,
				start_time_iso,
				end_time_iso,
				start_date,
				end_date,
				available_dates: dates,
				availability_code: this.availability_code,
			};

			try {
				await this.UpsertAvailability(body);
				store.commit('PUSH_NOTIFICATION', { component: 'locum-availability-updated', data: [''] });
				bus.$emit('change-context', 'locum-dashboard-landing-zone');
				setTimeout(() => {
					bus.$emit('UpdateCalendar');
				}, 500);
				this.close();
			} catch (err) {
				this.hasError = true;
			} finally {
				this.apiRequest = false;
			}
		},
		checkOverlap(timeSegments) {
			if (timeSegments.length === 1) return false;

			timeSegments.sort((timeSegment1, timeSegment2) => timeSegment1[0].localeCompare(timeSegment2[0]));

			for (let i = 0; i < timeSegments.length - 1; i++) {
				const currentEndTime = timeSegments[i][1];
				const nextStartTime = timeSegments[i + 1][0];

				if (currentEndTime > nextStartTime) {
					return true;
				}
			}

			return false;
		},
		checkExistingEvents(dates = []) {
			let requestsBlocker = false;
			let confirmedBlocker = false;
			let availabilityBlocker = false;
			const selectedTime = [this.starttime, this.endtime];
			if (this.professionalConfirmedBookings) {
				confirmedBlocker = this.professionalConfirmedBookings.some(booking =>
					booking?.booking_dates?.some(date => dates.includes(date) && this.checkOverlap([selectedTime, [booking.start_time, booking.end_time]]))
				);
			}
			if (this.professionalAvailability) {
				availabilityBlocker = this.professionalAvailability.some(availability =>
					availability?.available_dates?.some(
						date =>
							dates.includes(date) &&
							this.checkOverlap([selectedTime, [availability.start_time, availability.end_time]]) &&
							availability?.availability_code !== this.availability_code
					)
				);
			}
			return !requestsBlocker && !confirmedBlocker && !availabilityBlocker;
		},
	},
};
</script>
